
import { Line, Bar } from "react-chartjs-2";
import { useState} from 'react';
import {
Chart as ChartJS,
CategoryScale,
LinearScale,
BarElement,
Title,
PointElement,
LineElement,
Tooltip,
Legend,
ArcElement,
} from "chart.js";

ChartJS.register(
ArcElement,  
CategoryScale,
LinearScale,
PointElement,
LineElement,
BarElement,
Title,
Tooltip,
Legend
);


export function PageKonten3({globalOpsi}) {  
  const opsiCabang = globalOpsi.opsiCabang;
  const opsiReport =[
    "Irregular Wear Rate",
    "Overdue maintenance rate (%)",
    "Failure Rate",
    "Untracked Tire Rate",
    "Breakdown/Accident",
    "Tread Depth Deviations",
    "Rotation Interval (km)"
  ]
  const [report, setReport] = useState(opsiReport[0]); 

  const thisMonth = new Date().getMonth()+1; 
  const namaBulan = (x) =>
  new Intl.DateTimeFormat("id-ID", { month: "long" })
    .format(new Date(2026, x - 1, 1));
  const opsiBulan = Array.from({ length: 12 }, (_, i) => ({
    "angka_bln" : thisMonth - i,
    "nama_bulan": namaBulan(thisMonth - i)
  })); 
  
  return (
    <div>  
       <h2>Operational Risk</h2>
        {/* BAN GUDANG */}
        <div className="row text-center text-white py-2 mb-3" 
            style={{ background: "linear-gradient(90deg,#840072,#ff89ef)", borderRadius: 0 }}>
          {["Irregular Wear Rate", "Overdue Maintenance Rate", "Failure Rate", "Avg. TD Deviations"].map((x,i)=>(
            <div className="col" key={i}>
              <div className="fw-bold">{["2.3/1000 pcs", "11.23%" , "1.2 /1000 KM", "+3.3 mm"][i]}</div>{x}
            </div>
          ))}
        </div>

        {/* CHART */}
        <div className="row g-3">
          
          <div className="col-md-5">
                <select
                  className="form-select"
                  value={report}
                  onChange={(e)=>setReport(e.target.value)}
                >
                  { 
                    opsiReport.map((x) => (
                    <option key={x} value={x}>{x}</option>
                    ))
                  }
                </select>
              </div>
          <hr/>        
          <div className="flex justify-content-center col-md-12">
            
            {report === opsiReport[0] && <Sales opsiCabang={opsiCabang} opsiBulan={opsiBulan} title={opsiReport[0]} />}
            {report === opsiReport[1] && <SalesGrowth opsiCabang={opsiCabang} opsiBulan={opsiBulan} title={opsiReport[1]}/>}      
            {report === opsiReport[2] && <Sales2 opsiCabang={opsiCabang} opsiBulan={opsiBulan} title={opsiReport[2]} />}
            {report === opsiReport[3] && <Sales2 opsiCabang={opsiCabang} opsiBulan={opsiBulan} title={opsiReport[3]} />}
            {report === opsiReport[4] && <Sales2 opsiCabang={opsiCabang} opsiBulan={opsiBulan} title={opsiReport[4]} />}
            {report === opsiReport[5] && <Sales2 opsiCabang={opsiCabang} opsiBulan={opsiBulan} title={opsiReport[5]} />}      
          
          </div>
        </div>
      
    </div>
  );
}

//Grafik
function Sales({opsiCabang, opsiBulan, title}) {
  const thisMonth = new Date().getMonth()+1; 
  const [bulan, setBulan] = useState(thisMonth);

  const formatRibu = (value) => new Intl.NumberFormat("id-ID").format(value);
  const data = {
    labels: opsiCabang.filter(x => x.kode_cabang !== 'C-1').map(x => x.nama_cabang), //16
    datasets: [
      {
        label: "Penjualan",
        data: [
          95000, 140000, 80000, 110000, 50000,
          70000, 60000, 130000, 90000, 100000,
          85000, 75000, 65000, 105000, 115000,
          55000 
        ],
        backgroundColor: [
          "#4e79a7","#f28e2b","#59a14f","#e15759","#76b7b2",
          "#edc949","#af7aa1","#ff9da7","#9c755f","#bab0ab",
          "#1f77b4","#ff7f0e","#2ca02c","#d62728","#9467bd",
          "#8c564b"
        ],
        borderRadius: 3,
      },
    ],
  };

  const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          const total = context.dataset.data.reduce((a, b) => a + b, 0);
          const value = context.raw;
          const percent = ((value / total) * 100).toFixed(2);
          return `${formatRibu(value)} (${percent}%)`;
        },
      },
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        callback: function (value) {
          return value.toLocaleString("id-ID");
        },
      },
    },
  },
};

  return (
    <div className="mb-3 col-md-8">
      <h4 className="mx-3">{title}</h4>
        <div className="card mt-2"><div className="card-body">
        <div className="row flex justify-content-end">
            <div className="col-md-3">
                <select
                  className="form-select"
                  value={bulan}
                  onChange={e => setBulan(e.target.value)}
                >
                  { 
                    opsiBulan.map(x => (
                    <option value={x.angka_bln}>{x.nama_bulan}</option>
                    ))
                  }
                </select>
              </div>
          </div>              
        <Bar data={data} options={options} />
        </div></div>          
    </div>
  );
}

function SalesGrowth({opsiCabang, opsiBulan ,title}) {
  const [cabang, setCabang] = useState('');

  const formatRibu = (value) => new Intl.NumberFormat("id-ID").format(value);
  const data = {
    labels: opsiBulan.sort((a,b)=>a.angka_bln - b.angka_bln).map(b => b.nama_bulan),
    datasets: [
      {
        label: "KM",
        data: [75000, 65000, 75000, 71000, 75000, 73000, 76000, 73000, 64000, 73000, 65000, 78000],
        borderColor: "#0d6efd",
        tension: 0.2
      }
    ]
  };
  const options = {
      responsive:true, 
      plugins: { legend: { display:false }}
    };
  
  return (
    <div className="mb-3 col-md-8">
      <h4 className="mx-3">{title}</h4>
        <div className="card mt-2"><div className="card-body">
             <div className="row flex justify-content-end">
            <div className="col-md-4">
                <select
                  className="form-select"
                  value={cabang}
                  onChange={e => {setCabang(e.target.value)}}
                >
                  <option value = ''>Semua Cabang</option>
                  { 
                    opsiCabang.filter(x => x.kode_cabang !== 'C-1').map(x => (
                    <option value={x.nama_cabang}>{x.nama_cabang}</option>
                    ))
                  }
                </select>
              </div>
                </div> 
             <Line data={data} options={options} />     
        </div></div>
                
      </div>
  )
}

function Sales2({opsiCabang, opsiBulan, title}) {
  const thisMonth = new Date().getMonth()+1; 
  const [bulan, setBulan] = useState(thisMonth);
  const [cabang, setCabang] = useState('');

  const formatRibu = (value) => new Intl.NumberFormat("id-ID").format(value);
  const data = {
    labels: opsiCabang.filter(x => x.kode_cabang !== 'C-1').map(x => x.nama_cabang), //16
    datasets: [
      {
        label: "Penjualan",
        data: [
          95000, 140000, 80000, 110000, 50000,
          70000, 60000, 130000, 90000, 100000,
          85000, 75000, 65000, 105000, 115000,
          55000 
        ],
        backgroundColor: [
          "#4e79a7","#f28e2b","#59a14f","#e15759","#76b7b2",
          "#edc949","#af7aa1","#ff9da7","#9c755f","#bab0ab",
          "#1f77b4","#ff7f0e","#2ca02c","#d62728","#9467bd",
          "#8c564b"
        ],
        borderRadius: 3,
      },
    ],
  };

  const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          const total = context.dataset.data.reduce((a, b) => a + b, 0);
          const value = context.raw;
          const percent = ((value / total) * 100).toFixed(2);
          return `${formatRibu(value)} (${percent}%)`;
        },
      },
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        callback: function (value) {
          return value.toLocaleString("id-ID");
        },
      },
    },
  },
};

  return (
    <div className="mb-3 col-md-8">
      <h4 className="mx-3">{title}</h4>
        <div className="card mt-2"><div className="card-body">
        <div className="row flex justify-content-end">
            <div className="col-md-4">
                <select
                  className="form-select"
                  value={cabang}
                  onChange={e => {setCabang(e.target.value)}}
                >
                  <option value = ''>Semua Cabang</option>
                  { 
                    opsiCabang.filter(x => x.kode_cabang !== 'C-1').map(x => (
                    <option value={x.nama_cabang}>{x.nama_cabang}</option>
                    ))
                  }
                </select>
              </div>
            <div className="col-md-3">
                <select
                  className="form-select"
                  value={bulan}
                  onChange={e => setBulan(e.target.value)}
                >
                  { 
                    opsiBulan.map(x => (
                    <option value={x.angka_bln}>{x.nama_bulan}</option>
                    ))
                  }
                </select>
              </div>
          </div>              
        <Bar data={data} options={options} />
        </div></div>          
    </div>
  );
}